import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function UsersTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, agents, filteredUsers, searchTerm, sendAgreement, setSearchTerm, setStatusFilter, statusFilter } = ctx;

  return (
    <>
            {activeTab === 'users' && (
              <div className="users-content">
                <div className="content-header">
                  <h2>All Users ({filteredUsers.length})</h2>
                  <div className="filters">
                    <div className="search-box">
                      <Search size={20} />
                      <input
                        type="text"
                        placeholder="Search users..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                      <option value="all">All Types</option>
                      <option value="owners">Owners</option>
                      <option value="agents">Agents</option>
                      <option value="cashiers">Cashiers</option>
                    </select>
                  </div>
                </div>

                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>Agreement</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((user) => (
                        <tr key={user.id}>
                          <td>
                            <div className="user-info">
                              <Building size={16} />
                              {user.business_name}
                            </div>
                          </td>
                          <td>{user.email}</td>
                          <td>
                            <span className={`badge badge-${user.role}`}>
                              {user.is_agent ? 'Agent' : user.role}
                            </span>
                          </td>
                          <td>
                            <span className={`badge badge-${user.subscription_status}`}>
                              {user.subscription_status}
                            </span>
                          </td>
                          <td>{new Date(user.created_at).toLocaleDateString()}</td>
                          <td>
                            {user.agreement_signed ? (
                              <CheckCircle size={20} className="icon-success" />
                            ) : (
                              <XCircle size={20} className="icon-danger" />
                            )}
                          </td>
                          <td>
                            {!user.agreement_signed && (
                              <button 
                                className="btn-small btn-primary"
                                onClick={() => sendAgreement(user.email)}
                              >
                                <Mail size={16} /> Send Agreement
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
    </>
  );
}
